{
  "shell": {
    "menu": {
      "label": "Account menu",
      "close": "Close menu",
      "profile": "Profile",
      "signInSecurity": "Sign-in & security",
      "settings": "Settings",
      "rowCount": "{label}, {count}",
      "logOut": "Log Out"
    },
    "avatar": {
      "label": "Account"
    },
    "settings": {
      "title": "Settings",
      "appearance": "Appearance",
      "theme": "Theme",
      "themeSystem": "OS",
      "themeLight": "Light",
      "themeDark": "Dark",
      "language": "Language",
      "appLanguage": "App language"
    },
    "back": "Back"
  }
}
